"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _madLib = _interopRequireDefault(require("./mad-lib"));

var _sections = require("../contentful-views/sections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Avoid passing NaN as prop and pass `undefined` instead so default
 * prop will be used by descendant components
 */
var getNumber = function getNumber(object, path) {
  var value = _lodash["default"].get(object, path);

  var number = Number(value); // eslint-disable-next-line no-restricted-globals

  return isNaN(number) ? undefined : number;
};
/**
 * Contentful Widget to map MadLibForm to it's custom component.
 */


var MadLibWidget = function MadLibWidget(_ref) {
  var model = _ref.model;

  var madLibScreens = _lodash["default"].get(model, 'fields.madLibScreens');

  var popup = !!_lodash["default"].get(model, 'fields.popup');
  var delay = getNumber(model, 'fields.delay');

  var id = _lodash["default"].get(model, 'fields.id');

  var hidden = _lodash["default"].get(model, 'fields.hidden');

  var showAgainAfterDays = getNumber(model, 'fields.showAgainAfterDays');
  var maxShowCount = getNumber(model, 'fields.maxShowCount');
  var children = (0, _sections.getSectionsArray)(madLibScreens);
  return /*#__PURE__*/_react["default"].createElement(_madLib["default"], {
    delay: delay,
    popup: popup,
    id: id,
    hidden: hidden,
    showAgainAfterDays: showAgainAfterDays,
    maxShowCount: maxShowCount
  }, children);
};

MadLibWidget.propTypes = {
  model: _propTypes["default"].shape({})
};
MadLibWidget.defaultProps = {
  model: {}
};
(0, _sections.registerWidget)('madLibFlow', MadLibWidget);
var _default = MadLibWidget;
exports["default"] = _default;